import { API_URL } from '../utils/api';
import { ESTIMAT_CATEGORIES } from '../shared/config/estimatConfig';

// Hämta alla anpassade standardval från backend
export const fetchCustomStandardval = async () => {
  try {
    const response = await fetch(`${API_URL}/api/estimat-standardval/all`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.standardval || {};
  } catch (error) {
    console.error('Fel vid hämtning av anpassade standardval:', error);
    return {};
  }
};

// Skapa nytt anpassat standardval
export const createCustomStandardval = async (standardvalData) => {
  try {
    const response = await fetch(`${API_URL}/api/estimat-standardval`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(standardvalData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fel vid skapande av anpassat standardval:', error);
    throw error;
  }
};

// Uppdatera anpassat standardval
export const updateCustomStandardval = async (standardvalId, standardvalData) => {
  try {
    const response = await fetch(`${API_URL}/api/estimat-standardval/${standardvalId}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(standardvalData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fel vid uppdatering av anpassat standardval:', error);
    throw error;
  }
};

// Ta bort anpassat standardval
export const deleteCustomStandardval = async (standardvalId) => {
  try {
    const response = await fetch(`${API_URL}/api/estimat-standardval/${standardvalId}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fel vid borttagning av anpassat standardval:', error);
    throw error;
  }
};

// Kombinera statiska och anpassade standardval till en komplett config
export const buildCompleteEstimatConfig = async () => {
  try {
    // Hämta anpassade standardval
    const customStandardval = await fetchCustomStandardval();
    
    // Klona statisk config för att undvika mutation
    const completeConfig = JSON.parse(JSON.stringify(ESTIMAT_CATEGORIES));
    
    // Lägg till anpassade standardval till respektive kategorier
    Object.keys(customStandardval).forEach(categoryKey => {
      const customCategory = customStandardval[categoryKey];
      
      if (!completeConfig[categoryKey]) {
        console.warn(`Okänd kategori i anpassade standardval: ${categoryKey}`);
        return;
      }
      
      // Hantera subcategories (t.ex. byggoffert)
      Object.keys(customCategory).forEach(key => {
        if (key === 'items') {
          // Direkta items för kategorin
          if (!completeConfig[categoryKey].items) {
            completeConfig[categoryKey].items = [];
          }
          // Anpassade standardval kommer redan i rätt struktur från backend
          completeConfig[categoryKey].items.push(...customCategory.items);
        } else {
          // Subcategory items
          if (completeConfig[categoryKey].subcategories && completeConfig[categoryKey].subcategories[key]) {
            if (!completeConfig[categoryKey].subcategories[key].items) {
              completeConfig[categoryKey].subcategories[key].items = [];
            }
            // Anpassade standardval kommer redan i rätt struktur från backend
            completeConfig[categoryKey].subcategories[key].items.push(...customCategory[key]);
          }
        }
      });
    });
    
    return completeConfig;
  } catch (error) {
    console.error('Fel vid byggande av komplett estimat-config:', error);
    // Returnera bara statisk config om något går fel
    return ESTIMAT_CATEGORIES;
  }
};
